import React from 'react';
import { Link } from 'react-router-dom';
// import ReactDOM from 'react-dom';
// import jQuery from 'jquery';
// import { this.props.history } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../../actions/appointmentActions';
import * as documentActions from '../../../actions/documentUploadActions';
import Consultation from '../../sitemanagement/consultation';
import moment from 'moment';
import Moment from 'react-moment';
import * as ImageUrl from '../../../constants/constant';
import { confirmAlert } from 'react-confirm-alert';
import * as constant from "../../../constants/constant";
import 'react-confirm-alert/src/react-confirm-alert.css';

class consultationForm extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			patientHistory: [],
			appointmentDetails: [],
			showForm: 'none',
			showconsult: false,
			"chiefComplaints": "",
			"physicalExaminationFindings": "",
			"diagnosis": "",
			"treatmentPlan": "",
			"currentMedication": "",
			"prescription": "",
			"allergies": "",
			"familyHistory": "",
			"personalHistory": "",
			"pastHistory": "",
			"symptoms": '',
			'consultbuttonflag': 'block',
			'symptomsHistory': []
		};
		this.goToVideoCallPage = this.goToVideoCallPage.bind(this);
		this.Consult = this.Consult.bind(this)
		this.hideconsultationModal = this.hideconsultationModal.bind(this)
		this.onChange = this.onChange.bind(this)
		this.onChangeText = this.onChangeText.bind(this)
		this.saveConsultation = this.saveConsultation.bind(this)
	}
	goToVideoCallPage() {
		var videoCall = {
			appointmentId: localStorage.getItem('appointmentId'),
			patientId: localStorage.getItem('patientId'),
			doctorId: localStorage.getItem('userId')
		}
		localStorage.setItem('videoCall', JSON.stringify(videoCall))
		// this.props.history.push('/specialist/waiting-room-caller')
		window.open('/specialist/waiting-room-caller')
	}

	componentWillMount() {
        console.log("3333333333333333", this.props)
		localStorage.setItem('appointmentId', this.props.match.params.appointmentId);
		let appointmentObj = {
            appointmentId: 'dadsfsdf' 
            // localStorage.getItem('appointmentId')
		}
		this.props.actions.getConsultationDetail(appointmentObj);
		this.props.actions.getAppointmentDetails(appointmentObj);
		this.props.documentactions.getAppointmentDocument(appointmentObj);
		this.props.actions.getPatientAllConsultHistory({ patientId: localStorage.getItem('patientId') });
		if (localStorage.getItem('consult')) {
			this.setState({
				showForm: 'block'
			})
		}
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.consultationDet){

			this.setState({
				appointmentDetails: nextProps.appointmentDetails,
				patientHistory: nextProps.patientAllConsultHistory,
				consultationDet: nextProps.consultationDet,
				symptoms: nextProps.consultationDet.symptoms,
				allergies: nextProps.consultationDet.allergies,
				appointmentMode: nextProps.consultationDet.appointmentMode,
				chiefComplaints: nextProps.consultationDet.chiefComplaints,
				currentMedication: nextProps.consultationDet.currentMedication,
				diagnosis: nextProps.consultationDet.diagnosis,
				familyHistory: nextProps.consultationDet.familyHistory,
				gender: nextProps.consultationDet.gender,
				pastHistory: nextProps.consultationDet.pastHistory,
				patientName: nextProps.consultationDet.patientName,
				patientProfileImage: nextProps.consultationDet.patientProfileImage,
				personalHistory: nextProps.consultationDet.personalHistory,
				physicalExaminationFindings: nextProps.consultationDet.physicalExaminationFindings,
				prescription: nextProps.consultationDet.prescription,
				treatmentPlan: nextProps.consultationDet.treatmentPlan,
				appointmentDocument: nextProps.appointmentDocument,
				symptomsHistory: nextProps.patientAllConsultHistory.patientAppointments
			})
			if (Object.keys(nextProps.consultationDet).length > 7) {
				this.setState({
					'consultbuttonflag': 'none',
					'showForm': 'block'
				}, () => {
					console.log("8888888888888888888888888888888888", this.state)
				})
			}
		}
	}


	Consult() {
		this.setState({
			'showForm': 'block'
		})
	}

	hideconsultationModal() {
		this.setState({ showconsult: false });
	}

	// openconsultationModal(){
	// 	this.setState({ consultationModal: true});
	// }

	onChange(type) {
		if (type == 'past') {
			this.setState({ 'data': this.state.patientHistory.pastInfo })
			this.setState({ 'heading': 'Past History' })
		}
		if (type == 'family') {
			this.setState({ 'data': this.state.patientHistory.familyHistoryInfo })
			this.setState({ 'heading': 'Family History' })
		}
		if (type == 'personal') {
			this.setState({ 'data': this.state.patientHistory.personalInfo })
			this.setState({ 'heading': 'Personal History' })
		}
		if (type == 'allergy') {
			this.setState({ 'data': this.state.patientHistory.allergiesInfo })
			this.setState({ 'heading': 'Allergies History' })
		}
		if (type == 'prescription') {
			var patientId = localStorage.getItem('patientId');
			this.setState({ 'data': this.state.patientHistory.patientAppointments })
			this.setState({ 'heading': 'Prescriptions' })
		}
		if (type == 'docs') {
			var patientId = this.state.appointmentDetails.patient._id;
			this.setState({ 'patientId': patientId })
			this.setState({ 'data': this.state.appointmentDocument })
			this.setState({ 'heading': 'Uploaded Documents' })
		}
		if (type == 'syms') {
			var patientId = this.state.appointmentDetails.patient._id;
			this.setState({ 'patientId': patientId })
			this.setState({ 'data': this.state.appointmentDetails })
			this.setState({ 'heading': 'Uploaded Symptoms' })
		}
		this.setState({ showconsult: true });
	}

	saveConsultation() {
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to Save and Close the appointment?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						var consultObj = {
							"patientId": this.state.appointmentDetails.patient[0]._id,
							"appointmentId": localStorage.getItem('appointmentId'),
							"doctorId": localStorage.getItem('userId'),
							"chiefComplaints": this.state.chiefComplaints,
							"physicalExaminationFindings": this.state.physicalExaminationFindings,
							"diagnosis": this.state.diagnosis,
							"treatmentPlan": this.state.treatmentPlan,
							"currentMedication": this.state.currentMedication,
							"prescription": this.state.prescription,
							"allergies": this.state.allergies,
							"familyHistory": this.state.familyHistory,
							"personalHistory": this.state.personalHistory,
							"pastHistory": this.state.pastHistory,
							"symptoms": this.state.symptoms
						}
						this.props.actions.saveConsultation(consultObj, this.props)
					}
				},
				{
					label: 'No',
					onClick: () => {		}
				}
			]
		})


	}

	onChangeText(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	render() {
		let options = this.props.userTypeData;
		var defaultImagePath =
			constant.PRODUCTION_IMAGE_URL + "uploads/common/noUserImage.jpg";
		// let appointmentDetails = this.state.appointmentDetails;
		let patientHistory = this.state.patientHistory;
		let patientHisFlag = localStorage.getItem('patienthistory') ? localStorage.getItem('patienthistory') : '';
		let patientHisUrl = "/specialist/appointment-history/" + localStorage.getItem('patientId');
		let patientImage = this.state.appointmentDetails && this.state.appointmentDetails.patient ? ImageUrl.PRODUCTION_IMAGE_URL + 'uploads/' + this.state.appointmentDetails.patient[0]._id + '/' + this.state.appointmentDetails.patientdet[0].profileImage : '';

		return (
			<div className="content-wrapper">
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li>
											<a href="#tab_1" data-toggle="tab" className="active show">Consultation Form</a>
										</li>
										<li className=" col-md">
											<div className="content-header"><ol className="breadcrumb">
												<li> <Link to="/user/patients">Patients</Link></li>
												<li> <Link to={"/user/patient-appointments/" + localStorage.getItem('patientId')}>Patient Appointments History</Link></li>
												<li className="active">Consultation Form</li>
											</ol></div>
										</li>
									</ul>
									<div className="row">
										<div className="col-md-12">
											<div className="tab-content tabother">
												<div className="row">
													<div className="col-md-12">
														<div className="myfeedbackList">
															<div className="row">
																<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
																	<div className="row">
																		<div className="col-xs-12 col-sm-4 col-md-3 col-lg-3">
																			<img className="profile-user-img img-responsive img-circle" src={patientImage} alt="User profile picture" onError={e => {
																				e.target.src = defaultImagePath;
																			}} />
																		</div>
																		<div className="col-xs-12 col-sm-8 col-md-9 col-lg-9">
																			<h3 className="profile-username">{this.state.appointmentDetails && this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : ''}</h3>
																			<ul className="maldetails">
																				<li><Moment format="DD/MM/YYYY">{this.state.appointmentDetails && this.state.appointmentDetails.patientdet ? this.state.appointmentDetails.patientdet[0].dateOfBirth : ''}</Moment></li>
																				<li>{this.state.appointmentDetails && this.state.appointmentDetails.patientdet ? moment().diff(this.state.appointmentDetails.patientdet[0].dateOfBirth, 'years')!=0?
																				moment().diff(this.state.appointmentDetails.patientdet[0].dateOfBirth, 'years')+ ' Years'
																				:moment().diff(this.state.appointmentDetails.patientdet[0].dateOfBirth, 'months')+ ' Months' : ''} </li>
																				<li>{this.state.appointmentDetails && this.state.appointmentDetails.patientdet ? this.state.appointmentDetails.patient[0].gender : ''}</li>
																			</ul>
																			{/* <div className="historyappint">
																				{patientHisFlag == 'true' ? <Link to={patientHisUrl}> Appointment History</Link> : <Link to="/specialist/my-appointment" >Appointments</Link>}
																			</div> */}
																			{this.state.showconsult ? <Consultation openModal={this.state.showconsult} hideconsultationModal={this.hideconsultationModal} data={this.state.data} heading={this.state.heading} patientId={localStorage.getItem('patientId')} /> : ''}
																		</div>
																	</div>
																</div>
																<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
																	<div className="yelbtns pull-right" style={{ display: this.state.consultbuttonflag }}>
																		{this.state.appointmentDetails.appointmentMode == 2 ? <button type="button" className="btn btn-warning btn-lg confBtn " data-toggle="modal" data-target="#modal-default" onClick={this.goToVideoCallPage}>Conference Patient</button> : ''}  <button type="button" className="btn btn-warning btn-lg confBtn pdbtn" onClick={this.Consult} disabled={this.state.showForm == 'block'}>Consult</button>
																	</div>
																</div>
															</div>
															<div className="border"></div>
														</div>
													</div>
												</div>
												<div className="symptoms" style={{ 'display': this.state.showForm }}>
													<div className="row">
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Chief Complaints</span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={'Chief Complaints of ' + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span>
															<div className="m-t">
																<textarea className="form-control boxsymptom" name="chiefComplaints" id="chiefComplaints" onChange={this.onChangeText} ref="cheifCompliants" value={this.state.chiefComplaints} placeholder="" ></textarea>
															</div>
														</div>
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Symptoms </span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Symptoms of " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span>
															<span className="tooltip-custom fadeEffect tisymtomhover bookavatar" data-title="Check Uploaded Symptoms">
																<img src={require('../../../images/img/book.png')} alt="" onClick={this.onChange.bind(this, 'syms')} />
															</span>
															<span className="tooltip-custom fadeEffect tisymtomhover bookavatar" data-title="Check Uploaded Documents">
																<img src={require('../../../images/img/book.png')} alt="" onClick={this.onChange.bind(this, 'docs')} />
															</span>

															<div className="m-t">
																<textarea className="form-control boxsymptom" name="symptoms" id="symptoms" value={this.state.symptoms} onChange={this.onChangeText} ref="symptoms" placeholder="" ></textarea>
															</div>
														</div>
													</div>
													<div className="row m-t-20">
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Past History</span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Past History of " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span>
															<span className="tooltip-custom fadeEffect tisymtomhover bookavatar" data-title="Check Previous Past History">
																<img src={require('../../../images/img/book.png')} alt="" onClick={this.onChange.bind(this, 'past')} />
															</span>
															<div className="m-t">
																<textarea className="form-control boxsymptom" value={this.state.pastHistory} name="pastHistory" id="pastHistory" onChange={this.onChangeText} placeholder="" ></textarea>
															</div>
														</div>
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Family History </span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Family History of " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span>
															<span className="tooltip-custom fadeEffect tisymtomhover bookavatar" data-title="Check Previous Family History">
																<img src={require('../../../images/img/book.png')} alt="" onClick={this.onChange.bind(this, 'family')} />
															</span>
															<div className="m-t">
																<textarea className="form-control boxsymptom" name="familyHistory" id="familyHistory" value={this.state.familyHistory} onChange={this.onChangeText} ref="familHistory" placeholder="" ></textarea>
															</div>
														</div>
													</div>
													<div className="row m-t-20">
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Personal History</span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Personal History of " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span>
															<span className="tooltip-custom fadeEffect tisymtomhover bookavatar" data-title="Check Previous Personal History">
																<img src={require('../../../images/img/book.png')} alt="" onClick={this.onChange.bind(this, 'personal')} />
															</span>
															<div className="m-t">
																<textarea className="form-control boxsymptom" value={this.state.personalHistory} name="personalHistory" id="personalHistory" onChange={this.onChangeText} ref="personalHistory" placeholder="" ></textarea>
															</div>
														</div>
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Physical Examination Findings  </span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" style={{ 'word-break': 'break-all' }} data-title={"Physical Examination Findings of " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span >
															<div className="m-t">
																<textarea className="form-control boxsymptom" value={this.state.physicalExaminationFindings} name="physicalExaminationFindings" id="physicalExaminationFindings" onChange={this.onChangeText} ref="physicalExaminationFindings" placeholder="" ></textarea>
															</div>
														</div>
													</div>
													<div className="row m-t-20">
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Diagnosis</span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Diagnosis Information of " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span>
															<div className="m-t">
																<textarea className="form-control boxsymptom" value={this.state.diagnosis} name="diagnosis" name="diagnosis" onChange={this.onChangeText} ref="diagnosis" placeholder="" ></textarea>
															</div>
														</div>
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Treatment Plan  </span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Treatment Plan for " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span >
															<div className="m-t">
																<textarea className="form-control boxsymptom" value={this.state.treatmentPlan} name="treatmentPlan" id="treatmentPlan" onChange={this.onChangeText} ref="treatmentPlan" placeholder="" ></textarea>
															</div>
														</div>
													</div>
													<div className="row m-t-20">
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Allergies History</span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Allergies History of " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span>
															<span className="tooltip-custom fadeEffect tisymtomhover bookavatar" data-title="Check Previous Allergies History">
																<img src={require('../../../images/img/book.png')} alt="" onClick={this.onChange.bind(this, 'allergy')} />
															</span>
															<div className="m-t">
																<textarea className="form-control boxsymptom" value={this.state.allergies} name="allergies" id="allergies" onChange={this.onChangeText} ref="allergies" placeholder="" ></textarea>
															</div>
														</div>
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
															<span className="titlesymtoms">Current Medication  </span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Current Medication for " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span >
															<div className="m-t">
																<textarea className="form-control boxsymptom" value={this.state.currentMedication} name="currentMedication" id="currentMedication" onChange={this.onChangeText} ref="currentMedication" placeholder="" ></textarea>
															</div>
														</div>
													</div>
													<div className="row m-t-20">
														<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 offset-md-3">
															<span className="titlesymtoms">Prescription</span>
															<span className="tooltip-custom fadeEffect tisymtomhover helpsvg" data-title={"Prescription for " + (this.state.appointmentDetails.patient ? this.state.appointmentDetails.patient[0].userName : '')}>
															<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>
															</span>
															<span className="tooltip-custom fadeEffect tisymtomhover bookavatar" data-title="Check Previous Prescriptions">
																<img src={require('../../../images/img/book.png')} alt="" onClick={this.onChange.bind(this, 'prescription')} />
															</span>
															<div className="m-t">
																<textarea className="form-control boxsymptom" value={this.state.prescription} name="prescription" id="prescription" onChange={this.onChangeText} ref="prescription" placeholder="" ></textarea>
															</div>
														</div>

													</div>
													<div className="myfeedbtns">
														<div className="row">
															<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
																<div className="bottomBtn" style={{ display: this.state.consultbuttonflag }}>
																	<button type="button" className="btn btn-warning btn-lg" data-toggle="modal" data-target="#modal-default" onClick={this.saveConsultation.bind(this)}>Save and Close Appointment</button>
																	{patientHisFlag == 'true' ? <Link to={patientHisUrl} className="btn btn-cancel btn-default btn-lg"> Cancel</Link> : <Link to="/specialist/my-appointment" className="btn btn-cancel btn-default btn-lg">Cancel</Link>}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
		appointmentDetails: state.appointment.appointmentDetails,
		patientAllConsultHistory: state.appointment.patientAllConsultHistory,
		consultationDet: state.appointment.consultationDet,
		appointmentDocument: state.uploadDocument.uploadedImages ? state.uploadDocument.uploadedImages : ''
	};
}

// this tells what action should expose on props
// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
		documentactions: bindActionCreators(documentActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(consultationForm);
